import cnh from '~/helpers/cnh';
import formatDate from '~/helpers/formatDate';
import useTranslation from '~/hooks/useTranslation';
import orderBlockStyles from '~/styles/myEnvironment/order-block.module.css';
import { CustomerTravelplanResponse } from '~/types/api';
import IconCalendar from '~icons/tabler/calendar';
import IconFile from '~icons/tabler/file';

type Props = {
  className?: string;
  name?: string | null;
  startDate: string;
  endDate: string;
  lines: CustomerTravelplanResponse['order_blocks'][0]['lines'];
};

export default function OrderBlock({
  className,
  name,
  startDate,
  endDate,
  lines,
}: Props) {
  const translate = useTranslation();

  return (
    <div className={cnh(className, orderBlockStyles.orderBlock)}>
      <div className={orderBlockStyles.header}>
        {name && (
          <h3 className={orderBlockStyles.title}>
            {name}
          </h3>
        )}

        <div className={orderBlockStyles.meta}>
          <time
            className={orderBlockStyles.date}
            dateTime={startDate}
          >
            <IconCalendar />
            {formatDate(startDate)}
            {' – '}
            {formatDate(endDate)}
          </time>
        </div>
      </div>

      <ul className={orderBlockStyles.lines}>
        {lines.map((line) => (
          <li
            key={line.id}
            className={orderBlockStyles.linesItem}
          >
            <h4 className={orderBlockStyles.linesItemName}>
              {line.product?.name}
            </h4>

            {line.product?.media && line.product.media.length > 0 && (
              <div className={orderBlockStyles.linesItemMedia}>
                <strong className={orderBlockStyles.linesItemMediaTitle}>
                  {translate('myEnvironment.reservation.files_title')}
                </strong>

                {line.product.media.map((media) => {
                  const fileName = media.url.split('/').pop();

                  return (
                    <a
                      key={media.id}
                      className={orderBlockStyles.linesItemMediaItem}
                      href={media.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IconFile />
                      {fileName}
                    </a>
                  );
                })}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
